<template>
  <div style="overflow:hidden; position:relative">
    <v-row>
      <v-col cols="12" lg="10" style="margin: auto">
        <div class="pa-2">
          <v-img
            :src="chancharro"
            height="600"
            width="800"
            contain
            style="position: absolute; top: 650px; left: 0; filter: opacity(20%); transform: scaleX(-1);"
          ></v-img>
          <p class="display-1 font-weight-bold primary--text pt-6">
            Detalle buceo
          </p>

          <div class="d-flex pt-8">
            <v-btn
              @click="back"
              text
              color="primary"
              class="underline-decoration-custom pl-0 pr-0"
              tile
            >
              <v-icon left>mdi-chevron-left</v-icon>Volver
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :to="'/costa-pez/buceos/' + event.id + '/editar'"
              color="#c0e2e6"
              class="secondary--text font-weight-medium"
              v-if="editable"
              rounded
            >
              <SvgIcon icon="cp-edit" height="30px" fill="#004480"></SvgIcon>
              <span class="pl-3">Editar</span>
            </v-btn>
            <v-btn
              @click="dialogDelete = true"
              color="#c0e2e6"
              class="secondary--text font-weight-medium ml-3"
              v-if="editable"
              rounded
            >
              <v-icon>mdi-delete</v-icon>
              <span class="pl-3">Eliminar</span>
            </v-btn>
          </div>

          <v-row class="pt-8">
            <v-col cols="12" md="6">
              <p class="title secondary--text font-weight-bold pb-5">
                Buceo de {{ (event.recordedBy || {}).name }}
              </p>
              <v-card class="mb-4 mt-4" color="primary rounded-custom" dark>
                <v-card-title>
                  <SvgIcon
                    icon="cp-event-date"
                    size="30px"
                    fill="white"
                  ></SvgIcon>
                  <span class="pl-3">{{ event.eventDateLegible }}</span>
                </v-card-title>
                <EventListItemSwiper
                  v-if="event.id"
                  :id-event="event.id"
                ></EventListItemSwiper>
                <v-card-text class="card-custom-background">
                  <EventDetailBlock :event="event"></EventDetailBlock>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <EventDetailMap :event="event" v-if="event.id"></EventDetailMap>
            </v-col>
          </v-row>

          <v-divider class="primary mt-8 mb-10"></v-divider>

          <p class="title font-weight-bold primary--text">Avistamientos</p>
          <EventDetailOccurrenceList
            :list="event.occurrenceList"
          ></EventDetailOccurrenceList>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogDelete" max-width="600">
      <v-card>
        <v-card-title class="primary--text">Eliminar buceo</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="title pt-8 pb-8"
          >¿Seguro deseas eliminar el buceo?</v-card-text
        >
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="secondary" @click="dialogDelete = false"
            >Volver</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="deleteEvent" rounded width="140"
            >Si, eliminar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-img :src="IMG_0499" height="200" full-width position="0 40%"></v-img>
  </div>
</template>

<script>
import EventDetailMap from "./EventDetailMap";
import EventDetailOccurrenceList from "./EventDetailOccurrenceList";
import EventDetailBlock from "./EventDetailBlock";
import EventListItemSwiper from "./EventListItemSwiper";
import SvgIcon from "@/components/SvgIcon";

export default {
  components: {
    EventDetailMap,
    EventDetailOccurrenceList,
    EventDetailBlock,
    EventListItemSwiper,
    SvgIcon
  },
  data: () => ({
    IMG_0499: require("@/assets/landing/IMG_0499.jpg"),
    chancharro: require("@/assets/landing/chancharro.png"),
    event: {},
    editable: false,
    dialogDelete: false
  }),
  async mounted() {
    try {
      let { data: event } = await this.$http.get(
        "event/" + this.$route.params.id
      );
      this.event = event;
      this.editable = event.recordedBy.id == this.practitionerLogged.id;
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    async deleteEvent() {
      if (!this.event.id) {
        return;
      }

      for (let occurrence of this.event.occurrenceList) {
        await this.$http.delete("occurrence/" + occurrence.id);
      }
      await this.$http.delete("event/" + this.event.id);
      this.$router.push("/costa-pez/mis-buceos");
    }
  },
  computed: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    }
  }
};
</script>

<style></style>
